module.exports = __webpack_public_path__ + "static/background-2-d5ac72be11d69ca303d0fff1716688be.svg";